<template>
  <v-data-table
    :headers="headers"
    :items="items"
    hide-default-footer
    disable-pagination
    :items-per-page="-1"
    fixed-header
    dense
    :height="height"
  >
    <template v-slot:item="{ item, headers }">
      <tr>
        <td
          v-for="col in headers"
          :key="col.value"
          :class="col.align === 'center' ? 'text-center' : ''"
        >
          <slot
            :name="'item.' + col.value"
            :item="item"
          >
            {{ format(getValue(item, col.value)) }}
          </slot>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ChartListViewTable',

  props: {
    headers: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    height: {
      type: [Number, String],
      default: 350
    }
  },

  methods: {
    format(v) {
      return v === null || v === undefined || v === '' ? '–' : v
    },

    getValue(obj, path) {
      return path.split('.').reduce((o, k) => (o || {})[k], obj)
    }
  }
}
</script>
